import { createSelector, Selector } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

import { DocumentGeneric } from 'dashboard/models/document';
import { CaseAnalyticsFilterParams } from 'dashboard/redux/actions/case-analytics';
import { CasesFilterParams } from 'dashboard/redux/actions/cases';
import { RootState } from 'dashboard/redux/store';
import { ApiModel } from 'lib/interfaces/api';

const getCaseDocuments = (state: RootState) => [
  ...(state.case.caseToken
    ? state.case.case[state.case.caseToken].caseDetails?.inquiriesDetails?.documents || []
    : []),
  ...(state.case.caseToken
    ? state.case.case[state.case.caseToken].caseDetails.documents || []
    : []),
];

export const getCaseGenericDocuments = createSelector(
  [getCaseDocuments],
  (documents = []) =>
    documents.filter((document) => document.type === ApiModel.DocumentGeneric) as DocumentGeneric[],
);

const getCaseFilters = (state: RootState) => state.cases.filters;
const getCaseAnalyticsFilters = (state: RootState) => state.caseAnalytics.filters;

interface StartDateParams {
  startDate?: string | undefined;
  endDate?: string | undefined;
}

const getAdjustedFiltersForSelectors = <T extends StartDateParams>(selectors: Selector[]) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return createSelector(selectors, (filters: T) => {
    if (filters.startDate == null) {
      return {
        ...filters,
        startDate: null,
        endDate: null,
      };
    }
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const distance = DateTime.fromISO(filters.endDate).diff(
      DateTime.fromISO(filters.startDate),
      'seconds',
    ).seconds;
    const now = DateTime.local();

    const endOfDay = now.endOf('day');
    const adjustedEnd =
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      endOfDay < DateTime.fromISO(filters.endDate) ? endOfDay : DateTime.fromISO(filters.endDate);
    const adjustedStart = adjustedEnd.minus({ seconds: distance }).startOf('second');
    return {
      ...filters,
      startDate: adjustedStart.toISO(),
      endDate: adjustedEnd.toISO(),
    };
  });
};

export const getAdjustedCaseAnalyticsFilters =
  getAdjustedFiltersForSelectors<CaseAnalyticsFilterParams>([getCaseAnalyticsFilters]);

export const getAdjustedCaseFilters = getAdjustedFiltersForSelectors<CasesFilterParams>([
  getCaseFilters,
]);
